/* ==========================================================================
   GSJ — product page shipping note, corrected.

   The note on the product page (".gs-shipping-goal") is an EComposer
   custom-code block: its own HTML, CSS and inline script, pasted into the
   EComposer editor. It is NOT snippets/gs-shipping-goal.liquid, and it must not
   be edited in place, because EComposer regenerates the section whenever the
   page is re-saved. So this theme-owned script takes it over instead.

   What was wrong with it:
     - data-threshold-ca was hardcoded to 30000, so it kept advertising free
       shipping from $300 after the Shopify rate minimum moved to $250
     - it tested the cart total plus the piece, but not the reward the cart
       ladder will take off, which is what Shopify actually tests

   What this does, in order:
     1. rewrites the block's dataset from the "Shipping facts" theme settings
        BEFORE the EComposer script runs (this file is deferred, so it executes
        before DOMContentLoaded), which alone makes its own maths correct
     2. after DOMContentLoaded, rewrites the message, goal and delivery lines
        from GSJShipFact so the reward is accounted for and the wording comes
        from theme settings
     3. holds that with a small MutationObserver scoped to this one subtree, so
        a later EComposer repaint (variant change) is corrected too

   Currency (Sept 24 2026): every figure comes out of GSJShipFact in the
   shopper's currency (GSJShipFact.fx converts the CAD settings the way
   checkout does), so a US shopper reads US$15.00 shipping against a US$318.07
   goal, not CAD 14.90 dressed as "$14.90" against CAD 450. In a currency that
   cannot be converted reliably the note says shipping is calculated at
   checkout and drops the bar. This file also upgrades the product trust strip
   ("Insured Shipping" -> "Free Insured Shipping") for non-CAD shoppers, since
   snippets/gsj-pdp-trust-strip.liquid cannot convert.

   No polling and no animation frame loop.
   ========================================================================== */
(function () {
  'use strict';

  var F = window.GSJShipFact;
  if (!F) return;
  var cfg = F.cfg || {};

  function blocks() { return document.querySelectorAll('.gs-shipping-goal'); }

  /* Step 1 — correct the numbers the EComposer script itself reads. */
  function seed() {
    var caCents = F.thresholdCents('CA');
    var intlCents = F.thresholdCents('US');
    blocks().forEach(function (el) {
      el.dataset.thresholdCa = String(caCents);
      el.dataset.thresholdInt = String(intlCents);
    });
  }
  seed();

  function pieceCents(el) {
    var prices = {};
    try { prices = JSON.parse(el.dataset.variantPrices || '{}'); } catch (e) { prices = {}; }
    var id = null;
    try {
      var q = new URLSearchParams(window.location.search).get('variant');
      if (q && prices[q] != null) id = q;
    } catch (e) {}
    if (!id) {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value && prices[input.value] != null) id = input.value;
    }
    if (id) return parseInt(prices[id], 10) || 0;
    return parseInt(el.dataset.variantPrice || '0', 10) || 0;
  }

  /* The cart drawer server-renders its eligible subtotal on every page, so the
     reward estimate uses the real figure rather than guessing from the cart
     total. Absent (or stale after a mid-session add) it falls back to 0, which
     only ever makes the note more conservative. */
  function cartEligibleCents() {
    var promo = document.querySelector('#gs-cart-root [data-gs-eligible-cents]');
    return promo ? (parseInt(promo.getAttribute('data-gs-eligible-cents'), 10) || 0) : 0;
  }

  var pieceEligible = cfg.pieceEligible === true;
  var writing = false;

  /* End of our own write. MutationObserver callbacks are delivered LATER (as a
     microtask), by which time `writing` is already false again, so the flag
     alone never stopped the observer below from seeing our own writes: every
     paint queued a refresh, every refresh fetched /cart.js and painted again.
     Measured on the live product page Sept 30 2026: 264 /cart.js requests in
     75 seconds, for as long as the page stayed open. takeRecords() discards
     the records our writes just queued, so only EComposer's writes (the
     reason the observer exists) trigger a refresh. */
  function doneWriting(el) {
    if (el && el.__gsjObs) el.__gsjObs.takeRecords();
    writing = false;
  }

  function paint(el, cartCents) {
    var f = F.pieceFact({
      pieceCents: pieceCents(el),
      cartCents: cartCents,
      cartEligibleCents: cartEligibleCents(),
      pieceEligible: pieceEligible,
      country: cfg.country
    });

    var msg = el.querySelector('.gs-text') || el.querySelector('.gs-message');
    var goal = el.querySelector('.gs-goal-amount');
    var fill = el.querySelector('.gs-shipping-bar-fill') || el.querySelector('.gs-bar-fill');
    var icon = el.querySelector('.gs-icon');
    var delivery = el.querySelector('.gs-delivery-info') || el.querySelector('.gs-delivery');
    var goalLine = el.querySelector('.gs-goal-line');
    var track = el.querySelector('.gs-shipping-bar');

    writing = true;
    /* A currency GSJShipFact cannot state reliably: no rate, no goal, no bar. */
    if (!f) {
      el.classList.remove('gs-unlocked', 'gs--qualified');
      if (icon) icon.textContent = '';
      if (msg) msg.textContent = 'Shipping calculated at checkout';
      if (goalLine) goalLine.hidden = true;
      if (track) track.style.display = 'none';
      if (delivery && cfg.pdpDeliveryOther) delivery.textContent = cfg.pdpDeliveryOther;
      doneWriting(el);
      return;
    }
    if (track) track.style.display = '';
    if (f.unlocked) {
      el.classList.add('gs-unlocked', 'gs--qualified');
      if (icon) icon.textContent = '✓';
      if (msg) msg.textContent = cfg.pdpFree || 'This piece ships free, insured';
      if (fill) fill.style.width = '100%';
      /* Nothing left to chase, so the goal line is noise. */
      if (goalLine) goalLine.hidden = true;
    } else {
      el.classList.remove('gs-unlocked', 'gs--qualified');
      if (icon) icon.textContent = '';
      if (msg) {
        msg.textContent = (cfg.pdpChase || '[rate] shipping. Add [amount] more for free insured shipping')
          .replace('[rate]', F.money(f.rate))
          .replace('[amount]', F.money(f.remaining));
      }
      if (fill) fill.style.width = f.percent + '%';
      if (goalLine) goalLine.hidden = false;
    }
    if (goal) goal.textContent = F.money(f.threshold);
    if (goalLine && !goalLine.hidden && !goal) {
      goalLine.textContent = (cfg.pdpGoal || 'Free insured shipping goal: [threshold]')
        .replace('[threshold]', F.money(f.threshold));
    }
    if (delivery) {
      var express = Math.round((parseFloat(cfg.expressCA) || 0) * 100);
      var line = F.market(cfg.country) === 'ca'
        ? (cfg.pdpDeliveryCA || '').replace('[express]', F.moneyClean(express))
        : (cfg.pdpDeliveryOther || '');
      if (line) delivery.textContent = line;
    }
    doneWriting(el);
  }

  /* The product trust strip, for a cart not priced in CAD. The Liquid prints
     the paid wording and carries the piece price (shopper's currency) and its
     reward eligibility; the piece alone less the reward it would earn, exactly
     as the Liquid does for CAD. */
  function paintStrips() {
    var strips = document.querySelectorAll('[data-gsj-strip-ship]');
    Array.prototype.forEach.call(strips, function (s) {
      var f = F.pieceFact({
        pieceCents: parseInt(s.getAttribute('data-piece-cents') || '0', 10) || 0,
        cartCents: 0,
        cartEligibleCents: 0,
        pieceEligible: s.getAttribute('data-piece-eligible') === '1',
        country: cfg.country
      });
      s.textContent = f && f.unlocked
        ? (cfg.stripFree || 'Free Insured Shipping')
        : (cfg.stripPaid || 'Insured Shipping');
    });
  }

  var pending = null;
  function refresh(delay) {
    clearTimeout(pending);
    pending = setTimeout(function () {
      var els = blocks();
      if (!els.length) return;
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var basis = F.basisCents(cart, cfg.country);
          /* pieceFact adds the piece and subtracts the ladder reward itself, so
             it needs the cart WITHOUT the reward already taken off. */
          var cartCents = cfg.basis === 'before_discounts' && F.market(cfg.country) === 'ca'
            ? (cart.original_total_price || 0)
            : (cart.original_total_price || cart.total_price || 0);
          els.forEach(function (el) { paint(el, cartCents); });
          return basis;
        })
        .catch(function () {
          els.forEach(function (el) { paint(el, parseInt(el.dataset.cartTotal || '0', 10) || 0); });
        });
    }, delay || 0);
  }

  function start() {
    seed();
    paintStrips();
    refresh(0);

    /* Step 3 — hold it. The EComposer script writes the same nodes on its own
       schedule (DOMContentLoaded, variant change, and ~1.5s after an add), so
       correct it when it does. Scoped to these blocks; our own writes are
       dropped with takeRecords() in doneWriting(), so it cannot loop. */
    if (window.MutationObserver) {
      blocks().forEach(function (el) {
        var obs = new MutationObserver(function () {
          if (writing) return;
          refresh(60);
        });
        obs.observe(el, { childList: true, characterData: true, subtree: true });
        el.__gsjObs = obs;
      });
    }

    /* Follow the cart drawer too. Its qty changes and removes do not make
       EComposer repaint the note, and until Sept 30 2026 the note only kept up
       by accident, through the /cart.js loop fixed above. gs-panels.js
       announces every cart change on Dawn's pub/sub; PUB_SUB_EVENTS is a
       top-level const, not a window property, so it is read by name. */
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(0); });
      }
    } catch (e) { /* no pub/sub: the observer and events below still cover it */ }

    document.addEventListener('change', function () { refresh(80); }, true);
    window.addEventListener('popstate', function () { refresh(0); });
    ['cart:updated', 'cart:refresh', 'cart-update', 'ecom:cart:updated'].forEach(function (ev) {
      document.addEventListener(ev, function () { refresh(300); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
